<script lang="ts">
	import { postStore, setPostLocation } from '$lib/posts';
	import EditIcon from '$lib/components/common/EditIcon.svelte';
	import { getPlacenames } from '$lib/locations';
	import { onMount } from 'svelte';

	// export let create = false;
	export let view = false;
	let location;
	let placenames: string[] = [];
	const pageSize = 100;
	const page = 0;

	const fetchPlacenames = async () => {
		try {
			const names = await getPlacenames(page, pageSize);
			placenames = names;
		} catch (error) {
			console.error('Error fetching placenames:', error);
		}
	};

	const setLocation = async () => {
		// why is this labelled if not create? Don't we need to set the location on create?
		// if (!create) setPostLocation($postStore.id, $postStore.location);
		location = $postStore.location;
		await setPostLocation($postStore.id, $postStore.location);
		console.log('location', location);
	};

	onMount(async () => {
		await fetchPlacenames();
	});

	const labelText = 'text-cosmicCyan text-xs xl:text-sm';
	const placeholderBox = 'bg-cosmicPurple100 border-none rounded w-full';
	const textFieldLocation = 'text-lg md:text-xl xl:text-2xl';
</script>

{#if !view}
	<div class="grid grid-rows-4 gap-0 mt-2 font-exo-2">
		<div class="row-span-1 {labelText} ">local bloom</div>

		<div class="row-span-3">
			<div class="flex group w-full">
				<!-- IF UNDEFINED SHOW INPUT BOX -->
				{#if $postStore.location === undefined || $postStore.location == ''}
					<div class="border-none rounded w-full font-light text-gray-900">
						<select
							bind:value={$postStore.location}
							on:change={async () => await setLocation()}
							required
							class="font-regular ml-0 pl-1 -mx-3 py-1 md:py-2 {placeholderBox} {textFieldLocation}"
						>
							<!-- <option value="Creative">Creative</option> -->
							{#each placenames as place}
								<option value={place}>{place}</option>
							{/each}
						</select>
					</div>
				{:else}
					<!-- BUG: Once dropdown is selected, everything moves down 5+ px -->

					<!-- IF DEFINED -->
					<div class="flex group">
						<!-- SHOW CONTENTS -->
						<div class="group-hover:hidden w-full mt-2 {textFieldLocation}">
							{$postStore.location}
						</div>

						<div
							class="hidden group-hover:block border-none rounded w-full font-light text-gray-900 lg:mb-3"
						>
							<select
								bind:value={$postStore.location}
								on:change={async () => await setLocation()}
								class="font-regular ml-0 pl-1 -mx-3 py-1 md:py-2 {placeholderBox} {textFieldLocation}"
							>
								<!-- <option value="Creative">Creative</option> -->
								{#each placenames as place}
									<option value={place}>{place}</option>
								{/each}
							</select>
						</div>

						<!-- EDIT ICON ONLY SHOWS IF USER ENTERED DATA AND IS NOT HOVER STATE - THE ICON COULD STAY
						ON HOVER STATE IF THAT WAS LESS MOTION AND ACCEPTABLE CLUTTER -->
						<div class="pt-2 pl-3 group-hover:hidden">
							{#if $postStore.description === undefined || $postStore.description == ''}
								&nbsp;
							{:else}<EditIcon />{/if}
						</div>
					</div>
				{/if}
			</div>
		</div>
	</div>
{/if}
